
import { PopupContent } from '@/types/popup-system';

export interface MotivationalPopupStyle {
  id: string;
  name: string;
  backgroundColor: string;
  textColor: string;
  borderColor: string;
  titleBarColor: string;
  buttonColor: string;
  fontFamily: string;
  specialEffects?: string;
  shadowColor?: string;
}

export const MOTIVATIONAL_POPUP_STYLES: MotivationalPopupStyle[] = [
  {
    id: 'glitch-green',
    name: 'Terminal Glitch',
    backgroundColor: '#0a0a0a',
    textColor: '#00ff00',
    borderColor: '#00aa00',
    titleBarColor: '#003300',
    buttonColor: '#004400',
    fontFamily: 'Courier New, monospace',
    specialEffects: 'glitch',
    shadowColor: 'rgba(0, 255, 0, 0.3)'
  },
  {
    id: 'blood-red',
    name: 'Crimson Alert',
    backgroundColor: '#2a0a0a',
    textColor: '#ff3333',
    borderColor: '#aa0000',
    titleBarColor: '#440000',
    buttonColor: '#660000',
    fontFamily: 'Arial Black, sans-serif',
    specialEffects: 'pulse',
    shadowColor: 'rgba(255, 0, 0, 0.4)'
  },
  {
    id: 'void-purple',
    name: 'Cosmic Void',
    backgroundColor: '#1a0a2a',
    textColor: '#cc99ff',
    borderColor: '#6633aa',
    titleBarColor: '#330055',
    buttonColor: '#4d0077',
    fontFamily: 'Times New Roman, serif',
    specialEffects: 'float',
    shadowColor: 'rgba(153, 51, 255, 0.3)'
  },
  {
    id: 'rust-orange',
    name: 'Rusted Warning',
    backgroundColor: '#2a1a0a',
    textColor: '#ffaa33',
    borderColor: '#cc6600',
    titleBarColor: '#663300',
    buttonColor: '#884400',
    fontFamily: 'Verdana, sans-serif',
    specialEffects: 'shake',
    shadowColor: 'rgba(255, 153, 0, 0.3)'
  },
  {
    id: 'toxic-lime',
    name: 'Biohazard',
    backgroundColor: '#1a2a0a',
    textColor: '#aaff33',
    borderColor: '#66aa00',
    titleBarColor: '#334400',
    buttonColor: '#556600',
    fontFamily: 'Courier New, monospace',
    specialEffects: 'toxic-glow',
    shadowColor: 'rgba(170, 255, 51, 0.4)'
  },
  {
    id: 'deep-blue',
    name: 'Abyssal Depths',
    backgroundColor: '#0a1a2a',
    textColor: '#3399ff',
    borderColor: '#0066cc',
    titleBarColor: '#003366',
    buttonColor: '#004488',
    fontFamily: 'Georgia, serif',
    specialEffects: 'wave',
    shadowColor: 'rgba(51, 153, 255, 0.3)'
  },
  {
    id: 'spectral-cyan',
    name: 'Ghost Protocol',
    backgroundColor: '#0a2a2a',
    textColor: '#33ffcc',
    borderColor: '#00aa88',
    titleBarColor: '#004444',
    buttonColor: '#006666',
    fontFamily: 'Consolas, monospace',
    specialEffects: 'fade-in-out',
    shadowColor: 'rgba(51, 255, 204, 0.3)'
  },
  {
    id: 'magenta-nightmare',
    name: 'Digital Nightmare',
    backgroundColor: '#2a0a2a',
    textColor: '#ff33cc',
    borderColor: '#aa0088',
    titleBarColor: '#440044',
    buttonColor: '#660066',
    fontFamily: 'Impact, sans-serif',
    specialEffects: 'distort',
    shadowColor: 'rgba(255, 51, 204, 0.4)'
  },
  {
    id: 'amber-warning',
    name: 'System Alert',
    backgroundColor: '#2a2a0a',
    textColor: '#ffcc33',
    borderColor: '#ccaa00',
    titleBarColor: '#555500',
    buttonColor: '#777700',
    fontFamily: 'Trebuchet MS, sans-serif',
    specialEffects: 'blink',
    shadowColor: 'rgba(255, 204, 51, 0.3)'
  },
  {
    id: 'silver-static',
    name: 'Static Transmission',
    backgroundColor: '#1a1a1a',
    textColor: '#cccccc',
    borderColor: '#888888',
    titleBarColor: '#333333',
    buttonColor: '#555555',
    fontFamily: 'Lucida Console, monospace',
    specialEffects: 'static',
    shadowColor: 'rgba(204, 204, 204, 0.2)'
  }
];

export const createMotivationalPopupContent = (
  motivation: string,
  styleId: string,
  popupId: string
): PopupContent => {
  const style = MOTIVATIONAL_POPUP_STYLES.find(s => s.id === styleId) || MOTIVATIONAL_POPUP_STYLES[0];
  
  const titles = [
    'MOTIVATION PROTOCOL ACTIVATED',
    'DAILY INSPIRATION INCOMING',
    'SYSTEM MOTIVATION UPDATE',
    'PERSONAL DRIVE ENGAGED',
    'INSPIRATION MODULE LOADED',
    'MINDSET CALIBRATION',
    'WILLPOWER ENHANCEMENT',
    'PURPOSE REMINDER ACTIVE',
    'GOAL ALIGNMENT CHECK',
    'MENTAL STRENGTH BOOST'
  ];
  
  const randomTitle = titles[Math.floor(Math.random() * titles.length)];
  
  return {
    id: popupId,
    title: randomTitle,
    message: motivation,
    style: 'windows95',
    priority: 'medium',
    dismissible: true,
    autoCloseSeconds: 15,
    actionButtons: [
      {
        text: 'ACKNOWLEDGED (+10 XP)',
        action: 'close-with-xp',
        style: 'primary'
      }
    ]
  };
};
